import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import { useNavigate } from 'react-router-dom';  // Importar useNavigate
import { useLocation } from 'react-router-dom';

import { Toast } from 'primereact/toast';

import { IconField } from 'primereact/iconfield';

import { InputIcon } from 'primereact/inputicon';

import { confirmDialog } from 'primereact/confirmdialog';

import UpdateButton from '../../../Componentes/UpdateButton';

import DeleteButton from '../../../Componentes/DeleteButton';

import SidebarDCA from "../Clientes/SidebarDCA";

export default function CadastroDCAs(props) {
    const toast = React.useRef(null); // Ref para o Toast
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [edicao, setEdicao]= useState(false);
    const [dca, setDca] = useState([])
    const [dcas, setDcas] = useState([])
    const location = useLocation();
    const navigate = useNavigate();  // Hook para navegação
    const { dataEmpresa , filter} = location.state || {};
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            razaosocial: { value: '', matchMode: FilterMatchMode.CONTAINS },
            chavecoletor: { value: '', matchMode: FilterMatchMode.CONTAINS },
            hostname: { value: '', matchMode: FilterMatchMode.EQUALS },
            datacadastro: { value: '', matchMode: FilterMatchMode.EQUALS },
            dataativacao: { value: '', matchMode: FilterMatchMode.EQUALS },
            dataatualizacao: { value: '', matchMode: FilterMatchMode.EQUALS },
            dcaversao: { value: '', matchMode: FilterMatchMode.EQUALS }
        });
    const [fieldsFound, setFieldsFound] = useState([]);

    useEffect(()=>{
        getDca()
        console.log(filter)
    },[])


    useEffect(()=>{
        if(filter.filtered ){
            setGlobalFilterValue(filter.chave);
            onGlobalFilterChange({target : {
                    value : filter.chave
                }                
            })
            
        }
        
    },[filter.filtered])


            


    

    const getDca = async () => {
           setLoading(true)
            try {
                const response = await Conexao.post('dcaController/getDca',{
                    idusuario :dataEmpresa.idrevenda, 
                    idempresa :dataEmpresa.idempresa, 
                    idcliente :dataEmpresa.idcliente
                }                );
                setDcas(response.status === 200 && response.data.status === 'OK' ? response.data.payload : []);
                  setLoading(false)
            } catch {
                setDcas([]);
                 setLoading(false)
            }
        };

     const renderHeader = () => {
                    return (
                        <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '10px', paddingLeft : '0px'}}>
                           
                            <div className="flex align-items-center gap-2">
                                <IconField iconPosition="left">
                                    <InputIcon className="pi pi-search" />
                                    <InputText 
                                        disabled ={filter.filtered}
                                        value={globalFilterValue} 
                                        onChange={onGlobalFilterChange} 
                                        placeholder="Pesquisa global" 
                                        tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                                    />
                                </IconField>
                                <Button 
                                    icon="pi pi-filter-slash" 
                                    className="p-button-secondary p-button-sm" 
                                    onClick={clearFilters} 
                                    tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                                    disabled ={filter.filtered}
                                />
                                
                                <Button 
                                    
                                    icon="pi pi-sync" 
                                    className= "p-button-primary p-button-sm" 
                                    tooltip="Buscar dados" tooltipOptions={{ position: 'bottom' }}
                                    disabled ={filter.filtered}
                                    onClick={()=>{
                                        getDca()
                                                
                                    }}
                                />   

                                <Button 
                                    disabled ={filter.filtered}
                                    icon="pi pi-plus" 
                                    className= "p-button-primary p-button-sm" 
                                    tooltip="Cadastrar um novo DCA" tooltipOptions={{ position: 'bottom' }}
                                    onClick={()=>{
                                        navigate('/licencas-collector', { state: { ...location.state, isMobile : props.isMobile } });
                                                
                                    }}
                                />            
                            </div>
                            
                        </div>
                    );
                };

    const onGlobalFilterChange = (e) => {
    
            const value = e.target.value;

            setGlobalFilterValue(value);

            if(filter.filtered ){
                setFilters(prevFilters => ({
                    ...prevFilters,
                    global: { value, matchMode: FilterMatchMode.EQUALS }
                }));
            }else{
                    setFilters(prevFilters => ({
                    ...prevFilters,
                    global: { value, matchMode: FilterMatchMode.CONTAINS }
                }));
            }
            

        };
    const clearFilters = () => {
            setGlobalFilterValue('');
            setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
             razaosocial: { value: '', matchMode: FilterMatchMode.CONTAINS },
            chavecoletor: { value: '', matchMode: FilterMatchMode.CONTAINS },
            hostname: { value: '', matchMode: FilterMatchMode.EQUALS },
            datacadastro: { value: '', matchMode: FilterMatchMode.EQUALS },
            dataativacao: { value: '', matchMode: FilterMatchMode.EQUALS },
            dataatualizacao: { value: '', matchMode: FilterMatchMode.EQUALS },
            dcaversao: { value: '', matchMode: FilterMatchMode.EQUALS }
            });
            setFieldsFound([]); // Resetando os campos encontrados
        };

        const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };
    return (
        <Layout loading={false}>
            <div className="p-2">
              <DataTable
                                      value={dcas}
                                      header={renderHeader()}
                                      paginator                 
                                      rows={25} // Número de itens por página
                                      rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                                      responsiveLayout="scroll"
                                      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                                      tableStyle={{ minWidth: '35rem', fontSize : '10px' }}
                                      filters={filters}
                                      globalFilterFields={['chave','razaosocial', 'datacadastro', 'dataativacao', 'dataatualizacao', 'hostname', 'dcaversao']}
                                      bodyStyle={{fontSize : '10px'}}                            
                                      rowClassName={rowData => rowData.ativo === 'f' ? 'row-inativo' : ''}
                                  >
                                      <Column 
                                          bodyStyle={{ fontSize: '11px' , width : '15%', paddingTop:'8px', paddingBottom: '8px' }} 
                                          headerStyle={{ fontSize:'12px' }} 
                                          field="chave" 
                                          header="Chave DCA" 
                                          name="chave" 
                                          filter 
                                            filterElement={(options) => (
                                                <InputText
                                                    value={options.value}
                                                    onChange={(e) => options.filterCallback(e.target.value)}
                                                    onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                    placeholder="Digite a Chave"
                                                    />
                                            )}
                                          body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                          sortable 
                                              />
                                        <Column 
                                          bodyStyle={{ fontSize: '11px' , width : '25%', paddingTop:'8px', paddingBottom: '8px' }} 
                                          headerStyle={{ fontSize:'12px' }} 
                                          field="razaosocial" 
                                          header="Cliente" 
                                          name="razaosocial" 
                                          body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                          sortable 
                                          filter 
                                            filterElement={(options) => (
                                                <InputText
                                                    value={options.value}
                                                    onChange={(e) => options.filterCallback(e.target.value)}
                                                    onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                    placeholder="Digite a razão social"
                                                    />
                                            )}
                                              />
                  
                                      <Column 
                                          bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                                          headerStyle={{ fontSize:'12px' }} 
                                          field="datacadastro" 
                                          header="Criação" 
                                          name="datacadastro" 
                                          body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                          sortable 
                                          />
                  
                                      <Column 
                                          bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                                          headerStyle={{ fontSize:'12px' }} 
                                          field="dataativacao" 
                                          header="Instalação" 
                                          name="dataativacao" 
                                          body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                          sortable 
                                          />
                  
                                      <Column 
                                          bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                                          headerStyle={{ fontSize:'12px' }} 
                                          field="dataatualizacao" 
                                          header="Comunicação" 
                                          name="dataatualizacao" 
                                          body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                          sortable 
                                          />
                  
                                      <Column 
                                          bodyStyle={{ fontSize: '11px' , width : '15%', paddingTop:'8px', paddingBottom: '8px' }} 
                                          headerStyle={{ fontSize:'12px' }} 
                                          field="hostname" 
                                          header="Hostname" 
                                          name="hostname" 
                                          body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                          sortable 
                                          filter 
                                            filterElement={(options) => (
                                                <InputText
                                                    value={options.value}
                                                    onChange={(e) => options.filterCallback(e.target.value)}
                                                    onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                    placeholder="Digite o Número de patrimônio"
                                                    />
                                            )}
                                          />
                  
                                      <Column 
                                          bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                                          headerStyle={{ fontSize:'12px' }} 
                                          field="dcaversao" 
                                          header="Versão" 
                                          name="dcaversao" 
                                          filter 
                                            filterElement={(options) => (
                                                <InputText
                                                    value={options.value}
                                                    onChange={(e) => options.filterCallback(e.target.value)}
                                                    onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                    placeholder="Digite o Número de patrimônio"
                                                    />
                                            )}
                                          body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                          sortable 
                                          />
                                      <Column 
                                              bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px' , textAlign:'center' }} 
                                              headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px',  }} 
                                              header="Editar"
                                              body={(row)=> loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                                              <UpdateButton
                                                  disabled = {row.ativo ==='f' || props.fixarCliente}
                                                  style={{padding : '2px'}} className='w-full' onClick = {()=>{
                                                  setEdicao(true)
                                                  setDca(row)
                                              }}/>}                         
                                          />
                      
                                      <Column 
                                              bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px', textAlign:'center' }} 
                                              headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px',  }} 
                                              header="Excluir"
                                              body={(row)=> loading ? 
                                                          <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> 
                                                              : 
                                                          <DeleteButton severity="danger" style={{padding : '2px'}} className='w-full'
                                                          disabled = {row.ativo ==='f' || row.dataativacao || props.fixarCliente}
                                                          onClick={()=>{
                                                              confirmDialog({
                                                                  message: 'Confirma a EXCLUSÂO essa chave de instalação?',
                                                                  header: 'Confirmação',
                                                                  icon: 'pi pi-exclamation-triangle',
                                                                  acceptLabel: 'Sim',
                                                                  rejectLabel: 'Não',
                                                                  accept: () => {
                                                                  if(props.setLoading){
                                                                      props.setLoading(true)
                                                                  }
                                                                 
                                                                  props.Conexao.post('dcaController/removeDca', {
                                                                      idusuario : row.idusuario, 
                                                                      idempresa : row.idempresa, 
                                                                      idcliente : row.idcliente, 
                                                                      iddca : row.iddca
                                                                      }).then(response=>{
                  
                                                                          if(response.status == 200 && response.data.status == 'OK'){
                  
                                                                              setDcas(prevData => [...prevData.filter(item => item.iddca !== row.iddca )]); 
                  
                                                                              props.showMessage('success', 'Cadastro de Licenças', 'Registro removido com sucesso!')  
                  
                                                                          }else{
                  
                                                                              props.showMessage('warn', 'Cadastro de Licenças', 'Não foi possível remover registro')  
                  
                                                                          }
                  
                                                                          props.setLoading(false)      
                  
                                                                      }).catch(error=>{
                  
                                                                          props.showMessage('error', 'Cadastro de Licenças', 'Não foi possível remover registro')  
                  
                                                                          props.setLoading(false)      
                                                                                                      
                                                                      })
                          
                                                                      
                                                                  }
                                                                  }); 
                                                          }}/>}                         
                                          />
                  
                                  </DataTable>

            </div>
            <Toast ref={toast} />
            <SidebarDCA 
                getDca ={getDca} 
                showMessageToast ={showMessageToast} 
                dca = {dca} setDca = {setDca} locaisInstalacao = {[]} 
                showMessage ={(props.showMessageToast)}
                disabledLocais ={true}
                getLocaisByCliente ={props.getLocaisByCliente}/>
        </Layout>
    );
}
